export default {
  qInfo: { qType: 'visualization' },
  qHyperCubeDef: {
    qDimensions: [
      {
        qDef: {
          qFieldDefs: ['Survey'],
          qFieldLabels: ['respondentGroup'],
          qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }],
        },
        qNullSuppression: true,
      },
      {
        qDef: {
          qFieldDefs: ['Construct'],
          qFieldLabels: ['construct'],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['SubConstruct'],
          qFieldLabels: ['subConstruct'],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['SurveyQuestionCode'],
          qFieldLabels: ['surveyQuestionCode'],
        },
        qNullSuppression: true,
      },
      {
        qDef: {
          qFieldDefs: ['QuestionText'],
          qFieldLabels: ['questionText'],
        },
        qNullSuppression: true,
      },
    ],
    qMeasures: [
      {
        qDef: {
          qDef: `Sum({<[_CPYTD_Flag] = {1}>} 1)`,
          qLabel: 'Flag_CPY',
        },
      },
    ],
    qInitialDataFetch: [{ qWidth: 6, qHeight: 1666 }],
  },
}
